export const passwordValidations = {
  minLength: (value: string) => value.length >= 8,
  lowerCase: (value: string) => /[a-z]/.test(value),
  upperCase: (value: string) => /[A-Z]/.test(value),
  number: (value: string) => /\d/.test(value),
}
